import * as React from "react";
import styles = require("./empty.less");

interface PanelProps {
    description: React.ReactNode;
    imageSrc: string;
}

const Panel = (props: PanelProps) => {
    return <div className={styles.panel}>
            <div className={styles.header}>
                <img src={props.imageSrc} />
            </div>
            <div className={styles.body}>
                {props.description}
            </div>
        </div>;
};

export default Panel;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/GettingStarted/Panel.tsx